import Big from "big.js";
import { TableName } from "../../../redux/EditableTable/options";
import { store } from "../../../redux/store";
import { Type } from "../../../redux/Transaction/helper";
import { AppRoute } from "../../../routers/AppRouter/enum";

export const DepositItemHelper = {
    /** ---- formItems & linkItems  ---- */
    getItemsFromPanel(overrideTransactionType) {
        let parsedItems;
        const { linkItems, transactionType } = store.getState().Transaction;
        const { Editable } = store.getState();
        const { items: formItems } = Editable[TableName.form_item];
        const { items: bankItems } = Editable[TableName.bank_item];

        const parsedTransationType = overrideTransactionType || transactionType;
        switch (parsedTransationType) {
            case Type.sale_payment:
            case Type.sale_refund:
            case Type.purchase_payment:
            case Type.purchase_refund:
                parsedItems = linkItems;
                break;
            case Type.bank_income:
            case Type.bank_expense:
                parsedItems = bankItems;
                break;
            case Type.sale_invoice_cash:
            case Type.purchase_bill_cash:
            default:
                parsedItems = formItems || [];
                break;
        }
        return parsedItems;
    },

    // return linkSummaryData.applied  or formSummaryData.total based on transactionType
    getSummaryDataTotal(overrideTransactionType) {
        const isRecurring = window.location.pathname.includes(AppRoute.Instructions);
        let summaryDataTotal;
        const {
            formSummaryData,
            linkSummaryData,
            bankSummaryData,
            transactionType: trxTransactionType,
        } = store.getState().Transaction;
        const {
            transactionType: recurringTransactionType,
        } = store.getState().Instruction;
        const transactionType = isRecurring ? recurringTransactionType : trxTransactionType;

        const parsedTransationType = overrideTransactionType || transactionType;
        switch (parsedTransationType) {
            case Type.sale_payment:
            case Type.sale_refund:
            case Type.purchase_payment:
            case Type.purchase_refund:
                summaryDataTotal = linkSummaryData?.applied;
                break;
            case Type.bank_income:
            case Type.bank_expense:
                summaryDataTotal = bankSummaryData?.total;
                break;
            case Type.sale_invoice_cash:
            case Type.purchase_bill_cash:
            default:
                summaryDataTotal = formSummaryData?.total;
                break;
        }
        return summaryDataTotal;
    },

    normalizeData(newData, depositItems, includeAmount = false) {
        if (depositItems && depositItems.length) {
            // eslint-disable-next-line no-param-reassign
            newData.deposit_items = (depositItems || []).map(item => {
                const { amount, line } = item;
                const isAutoFill = line === 1 && !amount;

                // if autofill - infer amount from summarydata's total
                const parsedAmount = isAutoFill ? this.getSummaryDataTotal() : amount;
                return {
                    id: item.id || undefined,
                    payment_method_id: item.payment_method_id || null,
                    account_id: item.account_id || null,
                    amount: parseFloat(parsedAmount) || 0,
                    number: item.number || null,
                    fee_text: item.fee_text || null,
                    fee_amount: parseFloat(item.fee_amount) || null,
                    fee_account_id: item.fee_account_id || null,
                };
            });

            if (includeAmount) {
                // eslint-disable-next-line no-param-reassign
                newData.amount = depositItems.reduce((acc, item) => {
                    const { amount, line } = item;
                    const isAutoFill = line === 1 && !amount;
                    const parsedAmount = isAutoFill ? this.getSummaryDataTotal() : amount;
                    return new Big(parsedAmount || 0).plus(acc);
                }, new Big(0));
            }
        }
    },

    /**
    * summaryDataTotal - linkSummaryData.applied or formSummaryData.total
    */
    totalPayments: depositItems => {
        // const paymentTotal = parseFloat(
        //     depositItems.reduce((acc, item, index) => new Big(item.amount || 0).plus(acc), new Big(0)),
        // );
        // console.log('aaa totalPayments', depositItems);

        const paymentTotal = depositItems.reduce(
            (acc, item) => {
                // console.log('aaa totalPayments depositItems', item);
                const { line, amount } = item;
                const isAutoFill = line === 1 && !amount;
                // const parsedCurrentAmount = isAutoFill ? summaryDataTotal : item.amount;
                const parsedCurrentAmount = isAutoFill ?
                    DepositItemHelper.getSummaryDataTotal() :
                    item.amount;
                // console.log('aaa parsedCurrentAmount', parsedCurrentAmount);
                return new Big(parsedCurrentAmount || 0).round(2).plus(acc);
            },
            new Big(0));

        return paymentTotal.toNumber(); // as number
    },

    hasIncompleteItems: depositItems => {
        let hasError = false;

        depositItems.forEach((item, index) => {
            if (depositItems.length > 1 && !item.amount && index > 0)
                hasError = true;
            if (item.dirty)
                hasError = true;
            if (item.feeAmountDirty)
                hasError = true;
        });
        return hasError;
    },

    isFeeNonZero: feeText => {
        const feeAmount = parseFloat(feeText);
        return feeText && feeAmount !== 0 && !Number.isNaN(feeAmount);
    },

    getFeeAmount: (feeText, feeType = 'exclusive') => {
        const hasFeeText = ![null, undefined].includes(feeText);
        if (!hasFeeText)
            return null;

        const isNumeric = !feeText?.includes('%');
        const isPercentage = feeText?.includes('%');
        // const isNonZeroNumeric = isNumeric && parseFloat(feeText) !== 0;
        // const isNonZeroPercentage = isPercentage && parseFloat(feeText) !== 0;

        if (isNumeric)
            return parseFloat(feeText);
        if (isPercentage) {
            switch (feeType) {
                case 'inclusive': {
                    return null;
                }
                case 'exclusive':
                default:
                    return null;
            }
        }
        return null;

        // return isDefaultPaymentMethodFeeNumeric ?
        //     parseFloat(feeText) :
        //          null
    },

    shouldShowFee: (feeType, fee_text) => {
        const showFee =
        // Fee Exclusive (Payment Made - Money Out) - if the default payment method has non-null default fee amt
        // will only show fee if the fee is non-zero
        // eg: 2, 2%        -- ACCEPTED
        // eg: 0, 0%, EMPTY -- REJECTED
        (feeType === 'exclusive' && DepositItemHelper.isFeeNonZero(fee_text)) ||
                // Fee Inclusive (Payment Received - Money In) -  if the default payment method has non-null default fee amt
                // (eg 0, 0%, 2, 2%) -- ACCEPTED
                // EMPTY             -- REJECTED
                // the Fee Amount should be populated w default,
                // and thus the Fee Account should be selected with the default too.
                (feeType === 'inclusive' && ![null, undefined, ''].includes(fee_text));

        return showFee;
    },

    checkIsFeeExcluded: transactionType => [
        Type.sale_refund,
        Type.purchase_payment,
        Type.purchase_bill,
        Type.purchase_bill_cash,
        Type.bank_expense,
    ].includes(transactionType),

    getDefaultFeeInfo: (transactionType, paymentMethod = {}, settingsList = []) => {
        const {
            fee_text,
            fee_account_id,
        } = paymentMethod;

        let parsedSettings;
        if (settingsList)
            parsedSettings = settingsList;
        // Fallback to store if settingsList is not provided
        else
            parsedSettings = store.getState().List.settings;

        const isFeeExcluded = DepositItemHelper.checkIsFeeExcluded(transactionType); // Payment Made

        const feeType = isFeeExcluded ? 'exclusive' : 'inclusive';
        const feeAmount = DepositItemHelper.getFeeAmount(fee_text, feeType);
        const defaultFeeAccount = fee_account_id || parsedSettings.default_transaction_fee_account_id;
        const showFee = DepositItemHelper.shouldShowFee(feeType, fee_text);

        // console.log('aaa FeeAmountCell shouldShowFee', {
        //     feeType,
        //     nonZeroFee: DepositItemHelper.isFeeNonZero(fee_text),
        //     fee_text,
        //     feeAmount,
        //     showFee,
        //     defaultFeeAccount,
        // });
        return { showFee, feeAmount, defaultFeeAccount };
    },
};
